import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { EtpSommeilAccueilPage } from './AccueilPage';

export const LandingEtpSommeil = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <div className="h-full flex flex-col px-6 nsm:px-14">
      <EtpSommeilAccueilPage onNext={navigateNext} />
    </div>
  );
};
